import { client } from '@trello/graphql';
import { Action, actionCreator } from '@trello/redux';
import { memberId } from '@trello/session-cookie';
import { BoardResponse } from 'app/gamma/src/types/responses';
import { closedBoardsState } from 'app/gamma/src/modules/state/ui/closed-boards';
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
import { ClosedBoardsDocument } from './ClosedBoardsQuery.generated';

export const LOAD_CLOSED_BOARDS_SUCCESS = Symbol(
  'loaders/LOAD_CLOSED_BOARDS_SUCCESS',
);

export type LoadClosedBoardsSuccessAction = Action<
  typeof LOAD_CLOSED_BOARDS_SUCCESS,
  BoardResponse[]
>;

const loadClosedBoardsSuccess = actionCreator<LoadClosedBoardsSuccessAction>(
  LOAD_CLOSED_BOARDS_SUCCESS,
);

export const loadClosedBoards = (): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    closedBoardsState.setValue({ isLoading: true, hasError: false });

    const { data, error } = await client.query({
      query: ClosedBoardsDocument,
      variables: {
        id: memberId || '',
      },
      // eslint-disable-next-line @trello/disallow-fetch-policies
      fetchPolicy: 'network-only',
      context: {
        operationName: 'ClosedBoards',
        document: ClosedBoardsDocument,
      },
    });

    if (error) {
      closedBoardsState.setValue({ isLoading: false, hasError: true });
    } else if (data) {
      closedBoardsState.setValue({ isLoading: false, hasError: false });
      dispatch(loadClosedBoardsSuccess(data?.member?.boards));
    }
  };
};
